<lib-lca-container [primaryData]="primaryData" (onDialogClose)="handleDialogClose()" style="width:100%"></lib-lca-container>